import { useState, useContext, useEffect, useRef } from 'react';
import ApiContext from 'src/provider/API/call-service';
import utility from 'src/utils/utility'
import { CustomContainer, ScreenContainer } from 'src/style';
import { ReportFilter, ServerSideTable } from 'src/component';
import helpers from 'src/utils/helpers';
import { fixedDepositReportData, fixedDepositReportColumn } from 'src/utils/tableLayout';
import { useTranslation } from "react-i18next"


const FixedDepositReport = () => {
    const {API, downloadReport} = useContext(ApiContext)
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [showFilter, setShowFilter] = useState<boolean>(false)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const { t } = useTranslation()

    const filterDataRef = useRef({})
    
    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = await API.getFixedDepositReport(pageNumber, pageSize, {...filterDataRef.current, returnMax: isDownload})
        if (response) {
            if (isDownload) {
                return downloadReport(response, t('report.fixedDeposit.downloadFileName'))
            }
            setReportData(response)
            setReport(helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize}))
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    return (
        <>
            <ScreenContainer>
                <CustomContainer topMargin='3'>
                    <ServerSideTable
                        tableData={report}
                        tableColumns={fixedDepositReportColumn(t)} 
                        dataFetchMethod={handleFetchReport}
                        totalRows={reportData?.total}
                        tableTitle={t('report.fixedDeposit.tableTitle')}
                        customStyle
                        shouldResetPagination={resetPagination}
                        //canSearch
                        canFilter={() => setShowFilter(true)}
                        canClear={handleClear}
                        downloadAction={() => handleFetchReport(1, 10, true)}
                    />
                </CustomContainer>
            </ScreenContainer>
            { showFilter &&
                <ReportFilter
                    type='fixed-deposit'
                    onApplyFilter={handleFetchReport}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setShowFilter(false)} 
                />
            }
        </>
    )
}

export default utility.routeData('fixed-deposit-report', 'Fixed Deposit Report', <FixedDepositReport/>)